export function parseSize(size) {
  if (!size) return 0;
  const match = size.match(/([\d.]+)\s*MB/i);
  return match ? parseFloat(match[1]) : 0;
}

export function parsePrice(price) {
  if (!price) return 0;
  const match = price.match(/([\d.]+)/);
  return match ? parseFloat(match[1]) : 0;
}

export function parseRate(rate) {
  return rate ? parseFloat(rate) || 0 : 0; 
}
